import { useQuery } from '@tanstack/react-query';

// common
import { KEYS_QUERY } from 'common/constants';
import useService from 'common/hook/useService';
import { handleException } from 'modules/account/detail/helpers/utils';

// screen
import type { ReplaceGovAgency } from 'modules/account/types';

// export type GovAgency = typeof schemas.GovAgencyFromKios._type;
export type GovAgency = ReplaceGovAgency;

/**
 * Lấy danh sách đơn vị là Cơ quan quản lý
 */
const useGetListGovAgencies = () => {
  const service = useService();
  return useQuery({
    queryKey: [KEYS_QUERY.kiosGovAgencies],
    queryFn: async () => {
      try {
        if (!service) return [] as GovAgency[];
        const res = await service.KiosController_listGovAgencies();
        return res as GovAgency[];
      } catch (error) {
        handleException(error);
      }
    },
    staleTime: 1000 * 30,
  });
};

export default useGetListGovAgencies;
